var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.762,
    height: 16,
    viewBox: "0 0 21.762 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_003-mortarboard",
    "data-name": "003-mortarboard",
    transform: "translate(0 -67.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M20.965,71.059a97.543,97.543,0,0,0-9.356-3.174,2.636,2.636,0,0,0-1.455,0C8.008,68.5,5.937,69.161,4,69.85a.319.319,0,1,0,.213.6C6.138,69.767,8.2,69.11,10.329,68.5a2,2,0,0,1,1.1,0,96.91,96.91,0,0,1,9.295,3.153.632.632,0,0,1,0,1.174c-1.422.57-2.919,1.122-4.482,1.651a.318.318,0,0,0-.111-.089L11.018,71.95a.319.319,0,1,0-.274.576l4.674,2.226q-1.933.636-3.985,1.225a2,2,0,0,1-1.1,0,96.913,96.913,0,0,1-9.295-3.152.632.632,0,0,1,0-1.174c.644-.258,1.311-.516,1.985-.766a.319.319,0,0,0-.222-.6c-.679.252-1.352.512-2,.772a1.27,1.27,0,0,0,0,2.357q1.742.7,3.628,1.358v3.521a.95.95,0,0,0,.581.877,48.785,48.785,0,0,0,5.659,1.962.962.962,0,0,0,.519,0c1.6-.455,3.108-.955,4.494-1.491v1a1.19,1.19,0,0,0-.87,1.145v1.678a.319.319,0,0,0,.319.319h1.739a.319.319,0,0,0,.319-.319V81.785a1.19,1.19,0,0,0-.87-1.145V79.389q.266-.108.525-.217a.95.95,0,0,0,.582-.877v-.5a.319.319,0,1,0-.638,0v.5a.314.314,0,0,1-.192.29l-.277.116V75.124l.469-.16v1.55a.319.319,0,1,0,.638,0V74.744q1.837-.644,3.542-1.327a1.27,1.27,0,0,0,0-2.357ZM16.548,81.785v1.36h-1.1v-1.36a.551.551,0,0,1,1.1,0Zm-.87-2.828c-1.43.563-3,1.087-4.666,1.562a.329.329,0,0,1-.174,0,48.138,48.138,0,0,1-5.583-1.935.314.314,0,0,1-.192-.29v-3.3c1.63.557,3.331,1.091,5.09,1.6a2.636,2.636,0,0,0,1.455,0q2.094-.6,4.07-1.253Z",
    transform: "translate(0 0)",
    fill: "#356bb0"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.d14be8a6292864dd14085c0a49edcc16.svg";
export { ForwardRef as ReactComponent };